import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PhoneAppResource from "./PhoneAppResource";
import FileAppResource from "./FileAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";
import ServiceProviderProjectTypeAppResource from "./ServiceProviderProjectTypeAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import ServiceProviderCallToActionAppResource from "./ServiceProviderCallToActionAppResource";
import ServiceProviderLocationAppResource from "./ServiceProviderLocationAppResource";
import ServiceProviderRecommendationAppResource from "./ServiceProviderRecommendationAppResource";
import Engine from "@milestoneslabs/milestones-js-engine";
import LuStateAppResource from './LuStateAppResource';

export const SERVICE_PROVIDER = 'serviceProvider';

class ServiceProviderAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'website',
            'email',
            'contactUsPageUrl',
            'contactsUrl',
            'phoneUuid',
            'tagline',
            'description',
            'logoUuid',
            'marketsServedDescription',
            'parentUuid',
            'isNationalCompany',
            'hasMoreThan10Locations',
            'yelpIndustry',
            'yelpId',
            'sicCode',
            'linkedinUrl',
            'facebookUrl',
            'instagramUrl',
            'youtubeUrl',
            'houzzUrl',
            'thumbtackUrl',
            'porchUrl',
            'angiUrl',
            'yelpUrl',
            'phone',
            'logo',
            'parent',
            'types',
            'projectTypes',
            'locations',
            'contacts',
            'callToActions',
            'recommendations',
            'isVisible',
            'typeNames',
            'states',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            phone: PhoneAppResource,
            logo: FileAppResource,
            parent: ServiceProviderAppResource,
            types: ServiceProviderTypeAppResource,
            projectTypes: ServiceProviderProjectTypeAppResource,
            locations: ServiceProviderLocationAppResource,
            contacts: ServiceProviderContactAppResource,
            callToActions: ServiceProviderCallToActionAppResource,
            recommendations: ServiceProviderRecommendationAppResource,
            states: LuStateAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            phone: 'phone_uuid',
            logo: 'logo_uuid',
            parent: 'parent_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            website: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            email: {
                type: 'string',
                email: true,
                length: {
                    maximum: 255,
                },
            },
            contactUsPageUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            contactsUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            phoneUuid: {
                type: 'string',
            },
            tagline: {
                type: 'string',
                length: {
                    maximum: 10000,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 10000,
                },
            },
            logoUuid: {
                type: 'string',
            },
            marketsServedDescription: {
                type: 'string',
                length: {
                    maximum: 10000,
                },
            },
            parentUuid: {
                type: 'string',
            },
            isNationalCompany: {
                type: 'boolean',
            },
            hasMoreThan10Locations: {
                type: 'boolean',
            },
            yelpIndustry: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            yelpId: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            sicCode: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            linkedinUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            facebookUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            instagramUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            youtubeUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            houzzUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            thumbtackUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            porchUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            angiUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            yelpUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            isVisible: {
                type: 'boolean',
            },
        };
    }

    /**
     * @returns {{elasticsearch: *, search: *, restore: *, fetch: *, create: *, update: *, delete: *}}
     */
    apiPaths () {
        return {
            'elasticsearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/search/elastic',
            'favoriteElasticsearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/favorites/search/elastic',
            'popularElasticsearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/populars/search/elastic',
            'hasRecommendations': Engine.apiUrl(this.appResourceApiPrefix()) + '/has-recommendations',
            ...super.apiPaths(),
        }
    }

    async hasRecommendations(ownerUserUuid, organizationUuid) {
        return await new Promise((resolve, reject) => {
            Engine.xhrLib.post(this.apiPaths().hasRecommendations, {
                ownerUserUuid,
                organizationUuid,
            }).then(res => {
                resolve(res?.data?.data);
            });
        });
    }
}

export default ServiceProviderAppResource;
